import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-primary-navy text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          <div>
            <img
              src="https://static.readdy.ai/image/23008dfd20f0ddb4783f4060c01d33e6/b057788adbbe6a3240b4a9ae454c8b18.png"
              alt="TrackVerse"
              className="h-12 mb-4"
            />
            <p className="text-gray-400 mb-4">Global logistics simplified</p>
            <p className="text-gray-500 text-sm mb-4">Est. 2020 by Michael Ashley</p>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-primary-green transition-colors cursor-pointer"
              >
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a
                href="https://twitter.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-primary-green transition-colors cursor-pointer"
              >
                <i className="ri-twitter-x-fill text-lg"></i>
              </a>
              <a
                href="https://facebook.com"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="w-10 h-10 flex items-center justify-center bg-white/10 rounded-lg hover:bg-primary-green transition-colors cursor-pointer"
              >
                <i className="ri-facebook-fill text-lg"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase text-gray-500 mb-4">Services</h3>
            <ul className="space-y-3">
              <li>
                <a href="/services#ocean" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap cursor-pointer">
                  Ocean Freight
                </a>
              </li>
              <li>
                <a href="/services#air" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap cursor-pointer">
                  Air Freight
                </a>
              </li>
              <li>
                <a href="/services#road" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap cursor-pointer">
                  Road Transport
                </a>
              </li>
              <li>
                <a href="/services#rail" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap cursor-pointer">
                  Rail Logistics
                </a>
              </li>
              <li>
                <a href="/services#warehousing" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap cursor-pointer">
                  Warehousing
                </a>
              </li>
              <li>
                <a href="/services#customs" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap cursor-pointer">
                  Customs Clearance
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase text-gray-500 mb-4">Company</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/about" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/careers" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap">
                  Careers
                </Link>
              </li>
              <li>
                <Link to="/press" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap">
                  Press
                </Link>
              </li>
              <li>
                <Link to="/partner" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap">
                  Become a Partner
                </Link>
              </li>
              <li>
                <Link to="/contact" className="text-gray-300 hover:text-primary-green transition-colors whitespace-nowrap">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-sm font-semibold uppercase text-gray-500 mb-4">Get in Touch</h3>
            <ul className="space-y-4">
              <li className="flex items-start space-x-3">
                <i className="ri-mail-line text-primary-green mt-1"></i>
                <a
                  href="mailto:info.trackverse@gmail.com"
                  className="text-gray-300 hover:text-primary-green transition-colors cursor-pointer"
                >
                  info.trackverse@gmail.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-map-pin-line text-primary-green mt-1"></i>
                <span className="text-gray-300">
                  Building F, 18 Boulevard Tino Rossi, 20000 Ajaccio
                </span>
              </li>
              <li className="flex items-start space-x-3">
                <i className="ri-time-line text-primary-green mt-1"></i>
                <span className="text-gray-300">Mon-Sat, 8 AM - 7 PM</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-500 text-sm">
            © 2025 TrackVerse. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-500 hover:text-primary-green text-sm transition-colors whitespace-nowrap cursor-pointer">
              Privacy Policy
            </a>
            <a href="#" className="text-gray-500 hover:text-primary-green text-sm transition-colors whitespace-nowrap cursor-pointer">
              Terms of Service
            </a>
            <a
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-gray-500 hover:text-primary-green text-sm transition-colors whitespace-nowrap cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
